import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import ControlledInputText from 'components/common/forms/controlled_input_text';
import ControlledInputSelect from 'components/common/forms/controlled_input_select';
import { CA_PROVINCE_MAPPINGS } from 'constants/mappings';
import {
  POSTAL_CODE_REGEX_BY_COUNTRY,
  NO_URLS_REGEX,
} from 'constants/patterns';

const AddressFields = (props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const { address, namePrefix = '' } = props;

  const postalCodeFormatting = (postalCode) => {
    const noFormattingPostalCode = postalCode.replaceAll(/\W/g, '');
    return noFormattingPostalCode.length < 4
      ? noFormattingPostalCode
      : `${noFormattingPostalCode.slice(0, 3)} ${noFormattingPostalCode.slice(
          3,
        )}`;
  };

  return (
    <>
      <Grid item xs={12} md={12}>
        <ControlledInputText
          name={`${namePrefix}address_line_1`}
          control={control}
          defaultValue={address.address_line_1}
          maxlength={40}
          rules={{
            pattern: NO_URLS_REGEX,
            required: true,
            maxLength: 40,
          }}
          label={t('checkout.label.addressLine1')}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <ControlledInputText
          name={`${namePrefix}address_line_2`}
          control={control}
          defaultValue={address.address_line_2}
          maxlength={40}
          rules={{
            maxLength: 40,
            pattern: NO_URLS_REGEX,
          }}
          label={t('checkout.label.addressLine2')}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          name={`${namePrefix}locality`}
          control={control}
          defaultValue={address.sublocality_1 || address.locality}
          rules={{ required: true }}
          label={t('checkout.label.city')}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputSelect
          name={`${namePrefix}administrative_district_level_1`}
          control={control}
          defaultValue={address.administrative_district_level_1}
          rules={{ required: true }}
          options={Object.entries(CA_PROVINCE_MAPPINGS).map(([a, b]) => {
            return { value: a, displayValue: t(b) };
          })}
          label={t('checkout.label.state')}
          shouldMaskValues={true}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          name={`${namePrefix}postal_code`}
          control={control}
          defaultValue={address.postal_code}
          rules={{
            required: true,
            pattern: {
              value: POSTAL_CODE_REGEX_BY_COUNTRY.CA,
              message: t('error.validation.invalidPostalCode'),
            },
          }}
          label={t('checkout.label.postalCode')}
          transform={postalCodeFormatting}
        />
      </Grid>
    </>
  );
};

export default AddressFields;
